/**
 * Coup de pouce — Attendu 1095 « compléter des multiplications à trou ; lien
 * entre multiplication et division » (automatisme 4e, l. 636). UNE page
 * STATIQUE partagée par les trois generator_keys.
 *
 * L'image que l'élève a déjà : la barre de 1049 (5e), 13 partagé en 4 parts
 * égales, une part s'écrit 13/4. Le neuf de la 4e tient en UNE ligne de
 * plus, en langue d'élève : « 13/4, c'est 13 partagé en 4 : c'est 13 ÷ 4. »
 * Puis le cas où ça tombe juste, le fait de table sacrifié de 1047 :
 * « 56 ÷ 7 = 8, parce que 7 × 8 = 56. » Deux sacrifiés importés, aucun fait
 * nouveau perdu.
 *
 * SACRIFIÉS : (4 ; 13) et 7 × 8 = 56 dans les deux ordres (gen_1095,
 * COUPLES_SACRIFIES, auto-testé par gen1095.self.test.js).
 * Largeur bornée à 340 px, tailles de 1048, texte dans la figure.
 */

const ORANGE = '#EA580C';
const ORANGE_CLAIR = '#FED7AA';
const BLEU = '#2563EB';
const VERT = '#15803D';
const GRIS = '#E2E8F0';
const ENCRE = '#1E293B';

const XB = 40;
const WB = 320;
const NB = 4;
const WM = WB / NB;

/** Une fraction empilée, une couleur. */
const frac = (x, y, n, d, couleur, taille, demi) => `
  <text x="${x}" y="${y - 4}" font-size="${taille}" font-weight="bold" text-anchor="middle" fill="${couleur}">${n}</text>
  <line x1="${x - demi}" y1="${y}" x2="${x + demi}" y2="${y}" stroke="${couleur}" stroke-width="1.8"/>
  <text x="${x}" y="${y + taille + 1}" font-size="${taille}" font-weight="bold" text-anchor="middle" fill="${couleur}">${d}</text>`;

const PARTS = Array.from({ length: NB }, (_, k) => {
    const x = XB + k * WM;
    return `<rect x="${x}" y="96" width="${WM}" height="36" fill="${ORANGE_CLAIR}" stroke="${ORANGE}" stroke-width="2"/>
  ${frac(x + WM / 2, 114, 13, 4, ORANGE, 10, 8)}`;
}).join('\n  ');

const SVG_PARTAGE = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 296" width="100%" style="max-width:340px;height:auto;display:block" role="img"
     aria-label="4 fois quel nombre égale 13 ? Une barre entière de 13, et dessous la même longueur coupée en 4 parts égales, chacune étiquetée 13 sur 4. Le nombre cherché, c'est 13 sur 4. 13 sur 4, c'est 13 partagé en 4 : c'est 13 divisé par 4. Quand ça tombe juste, c'est un fait de table : 56 divisé par 7 égale 8, parce que 7 fois 8 égale 56.">
  <text x="200" y="30" font-size="16" font-weight="bold" text-anchor="middle" fill="${ENCRE}"><tspan fill="${BLEU}">4</tspan> × <tspan fill="${ORANGE}">?</tspan> = <tspan fill="${VERT}">13</tspan></text>
  <rect x="${XB}" y="48" width="${WB}" height="36" fill="${GRIS}" stroke="${ENCRE}" stroke-width="1.5"/>
  <text x="200" y="73" font-size="15" font-weight="bold" text-anchor="middle" fill="${VERT}">13</text>
  ${PARTS}

  <!-- le résultat -->
  <text x="176" y="178" font-size="17" font-weight="bold" text-anchor="end" fill="${ENCRE}"><tspan fill="${ORANGE}">?</tspan> =</text>
  ${frac(198, 171, 13, 4, ORANGE, 15, 12)}
  <text x="218" y="178" font-size="17" font-weight="bold" fill="${ENCRE}">= <tspan fill="${VERT}">13</tspan> ÷ <tspan fill="${BLEU}">4</tspan></text>

  <!-- le geste, puis le cas de table -->
  <text x="200" y="222" font-size="12" text-anchor="middle" fill="${ENCRE}"><tspan font-weight="bold" fill="${VERT}">13</tspan> partagé en <tspan font-weight="bold" fill="${BLEU}">4</tspan> parts égales : une part, c'est 13 ÷ 4.</text>
  <text x="200" y="256" font-size="12" text-anchor="middle" fill="${ENCRE}">Quand ça tombe juste, c'est un fait de table :</text>
  <text x="200" y="278" font-size="13" font-weight="bold" text-anchor="middle" fill="${ENCRE}">56 ÷ 7 = 8, parce que 7 × 8 = 56.</text>
</svg>`.trim();

const AIDE = { pages: [{ titre: '13 partagé en 4', svg: SVG_PARTAGE }] };

const CP_1095 = {
    flash_texte_trou_saisie: AIDE,
    calcul_qcm_unique: AIDE,
    sens_relier: AIDE,
};

export default CP_1095;
